var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYinYang(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 128C238.32 128 224.031 142.375 224.031 160S238.32 192 256 192S287.969 177.625 287.969 160S273.68 128 256 128ZM256 16C123.461 16 16 123.418 16 256C16 388.578 123.461 496 256 496S496 388.578 496 256C496 123.418 388.539 16 256 16ZM256 384C238.32 384 224.031 369.625 224.031 352S238.32 320 256 320S287.969 334.375 287.969 352S273.68 384 256 384ZM256 256C202.961 256 159.973 299 159.973 352S202.961 448 256 448C149.922 448 63.945 362 63.945 256C63.945 150 149.922 64 256 64C309.039 64 352.027 107 352.027 160S309.039 256 256 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYinYang);
export default __webpack_public_path__ + "static/media/yin-yang.ae4b7da1d4451ea9a04fd341189cfcc5.svg";
export { ForwardRef as ReactComponent };